import { Injectable } from '@angular/core';
import { DialogService } from './dialog.service';
import { SessionTakeoverDialogComponent } from '../components/dialogs/session-takeover-dialog/session-takeover-dialog.component';
import { ApiService } from './api.service';
import { ActiveSessionModel, ActiveSessionsByAnywhereClientModel } from '../models/active-session.model';
import { Observable, take } from 'rxjs';
import { LicenseEnforcementModel } from '../models/license-enforcement.model';
import { DocumentModel } from '../models/document.model';
import { AutologinForSessionTakeoverResponse, AutologinModel } from '../models/autologin.model';
import { SessionImageRequest } from '../models/session-image-request';
import { SessionImageModel } from '../models/session-page.model';

@Injectable()
export class SessionService {
  constructor(private dialogService: DialogService, private apiService: ApiService) {}

  public openSessionTakeoverDialog(sessions: any[]) {
    const modalRef = this.dialogService.openCustomDialog('Sessiontakeover', SessionTakeoverDialogComponent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.sessions = sessions;
  }

  public checkLicenseCount() {
    let licenseCountExceeded = sessionStorage.getItem('licenseCountExceeded');
    if (licenseCountExceeded === 'true') {
      this.getActiveSessions()
        .pipe(take(1))
        .subscribe((res) => {
          if (res && res.sessions) {
            this.openSessionTakeoverDialog(res.sessions);
            sessionStorage.removeItem('licenseCountExceeded');
          }
        });
    }
  }

  public createAutologinForSessionTakeover(session: ActiveSessionModel): Observable<AutologinModel> {
    return this.apiService.post('session/CreateAutologinForSessionTakeover', { session: session });
  }

  public completeTakeover(session: ActiveSessionModel) {
    return this.apiService.post('session/completeTakeover', { session: session });
  }

  public getPendingCaseSessions(casId: string): Observable<ActiveSessionModel[]> {
    return this.apiService.post<ActiveSessionModel[]>('session/getpendingcasesessions', { casId: casId });
  }

  public closeSession(session: ActiveSessionModel): Observable<LicenseEnforcementModel> {
    return this.apiService.post('session/close', { session: session });
  }

  public saveDocumentAndcloseSession(session: ActiveSessionModel): Observable<LicenseEnforcementModel> {
    return this.apiService.post('session/saveandclose', { session: session });
  }

  public resumeSession(sessionId: string, txTextSessionId: string, dcmId: string = ''): Observable<DocumentModel> {
    return this.apiService.post('session/resume', {
      autosaveSessionId: sessionId,
      txTextSessionId: txTextSessionId,
      dcmId: dcmId,
    });
  }

  public getActiveSessions(): Observable<any> {
    return this.apiService.post('session/getactivesessions', {});
  }
  public getFirmSessions(): Observable<any> {
    return this.apiService.post('session/getfirmsessions', {});
  }

  public getSessionThumbnail(session: ActiveSessionModel): Observable<Blob> {
    const sessionImageRequest: SessionImageRequest = {
      ...session, // This will copy all matching properties
    };

    return this.apiService.post<Blob>(
      'session/GetSessionThumbnail',
      sessionImageRequest,
      // wierd hack below to make response type a blob.
      { responseType: 'blob' as 'json' }
    );
  }

  public sendNotificationBeacon(e: any) {
    const postData = {
      code: e.code,
      reason: e.reason,
      wasClean: e.wasClean,
    };
    this.apiService.sendBeacon('session/notify', postData);
  }
}
